module.exports = __webpack_public_path__ + "img/drlaura_hero_mobile.491110a3.png";